<template>
  <div id='app'>
    <transition name="pulldown">
      <top-navigation :key="$loaded" :v-if="$loaded" :class="{ hide : hideTopNavigation }" />
    </transition>
    <transition name="fade">
      <router-view :key="$route.path" />
    </transition>
    <bottom-footer />
    <stylesheets />
  </div>
</template>

<script>
module.exports = {
  data: function() {
    return {
      hideTopNavigation: false
    };
  },
  created() {
    this.$on('ToggleOverlay', event => {
      this.hideTopNavigation = !this.hideTopNavigation;
      console.log(this.hideTopNavigation);
    });
  },
  computed: {
    $loaded: {
      get () {
        return this.$store.state.loaded
      }
    }
  }
}
</script>
